module.exports = __webpack_public_path__ + "img/address-default@2x.6f0064be.png";